import * as React from "react"
import { Flex, Box } from "@chakra-ui/react"

export const Overlay = ({ title, description }) => {
  return (
    <Flex
      width="100%"
      height="100%"
      position="fixed"
      background="white"
      zIndex="100000000000000000"
      backgroundColor="rgba(255, 255, 255, 0.7)"
      justify="center"
      align="center"
    >
      <Box
        w={["100%", 400]}
        mx={4}
        boxShadow={"md"}
        padding="1rem"
        backgroundColor="rgba(255, 255, 255)"
        borderRadius="0.375rem"
        // justifyContent="center"
        // alignItems="center"
        // direction="row"
        // width={
        //   isMobile ? (isLandscape ? "400px" : "calc(100% - 40px)") : "400px"
        // }
        // w="100%"
        // px={4}
        // position="absolute"
        // top="50%"
        // left="50%"
        // marginRight="-50%"
        // transform="translate(-50%, -50%)"
        // flexDirection="column"
      >
        <Box
          fontSize="1.25rem"
          lineHeight="1.5"
          fontWeight="500"
          marginBottom="0.5rem"
          zIndex="10000001"
          textAlign={["center", "unset"]}
        >
          {title}
        </Box>
        <Box textAlign={["center", "unset"]}>{description}</Box>
      </Box>
    </Flex>
  )
}
